import { useQuery } from '@tanstack/react-query';
import { terraProxyApiClient } from '../../clients/testerClient';

export const EXTERNAL_NETWORK_SIGNALS_TREND_KEY =
  'external-network-signals-trend';

const STALE_TIME_MS = 30_000;

export function useExternalNetworkSignalsTrend({
  surfaceId,
  days = 30,
  enabled = true,
}: {
  surfaceId: string | null;
  days?: number;
  enabled?: boolean;
}) {
  const query = useQuery({
    queryKey: [EXTERNAL_NETWORK_SIGNALS_TREND_KEY, surfaceId, days],
    queryFn: () =>
      terraProxyApiClient.getExternalNetworkSignalsTrend({
        surfaceId: surfaceId ?? '',
        days,
      }),
    enabled: Boolean(surfaceId) && enabled,
    staleTime: STALE_TIME_MS,
  });

  return {
    trend: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
